/*
 * decaffeinate suggestions:
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import Actions from "okpay/actions/Actions";
import PurchaseButton from "okpay/components/PurchaseButton";
import C from "okpay/util/Constants";
import Str from "shared/components/Str";
import _str from "shared/util/_str";

import "./paypalform.scss";

function __guard__(value, transform) {
	return typeof value !== "undefined" && value !== null
		? transform(value)
		: undefined;
}

const PayPalForm = ({ productId, hasPaypal, paypal }) => {
	let paypalBody;
	const aboutLink =
    "https://www.paypal.com/cgi-bin/webscr?" +
    "cmd=xpt/Marketing/popup/OLCWhatIsPayPal-outside";

	let paypalAbout = (
		<div className="okpay-paypal-about">
			<a href={aboutLink} target="_blank" rel="noopener noreferrer">
				<Str>What is PayPal?</Str>
			</a>
		</div>
	);

	if (productId === "update") {
		let paypalRemove;
		let paypalAddText = _str("Add PayPal Account");

		if (hasPaypal) {
			paypalAddText = _str("Update PayPal Account");
			paypalRemove = (
				<div className="okpay-paypal-update">
					<a
						className="blue flatbutton okpay-paypal-action"
						href="/paypal?remove_agreement=1"
						target="_parent"
					>
						<Str>Remove PayPal Account</Str>
					</a>
				</div>
			);
		}

		const paypalAdd = (
			<div className="okpay-paypal-update">
				<a
					className="blue flatbutton okpay-paypal-action"
					href="/paypal?add_no_plan=1"
					target="_parent"
				>
					{paypalAddText}
				</a>
				{paypalAbout}
			</div>
		);

		paypalBody = (
			<div className="okpay-paypal-update">
				{paypalAdd}
				{paypalRemove}
			</div>
		);
	} else {
		if (hasPaypal && paypal != null && paypal.agreement && paypal.agreement.email) {
			const email = paypal.agreement.email;
			paypalAbout = <div className="okpay-paypal-about">Paying as {email}</div>;
		}

		paypalBody = (
			<div className="okpay-paypal-purchase">
				<PurchaseButton>
					<Str>Continue with PayPal</Str>
				</PurchaseButton>
				{paypalAbout}
			</div>
		);
	}

	return <div className="okpay-paypal">{paypalBody}</div>;
};

export default PayPalForm;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/PayPalForm.jsx